import { ReactNode, useEffect, useRef } from 'react';

import { Box } from '@mui/material';
import { injectContextHeaders } from '@tecma/logs-fe';
import { observer } from 'mobx-react';

import { IS_DEVELOPMENT } from '../constants/general';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { sliceEnvironment } from '../redux/slice/slice.environment';
import { thunkEnvironment } from '../redux/thunks/thunk.environment';
import Loader from './Loader';

interface Props {
  children: ReactNode;
}

export const ProviderEnvironment = observer(({ children }: Props) => {
  const environment = useAppSelector(sliceEnvironment.selectors.environment);
  const dispatch = useAppDispatch();
  const contextHeadersInjected = useRef(false);

  useEffect(() => {
    dispatch(thunkEnvironment());
  }, []);

  useEffect(() => {
    if (
      IS_DEVELOPMENT ||
      contextHeadersInjected.current ||
      !environment.REACT_APP_APOLLO_URI
    ) {
      return;
    }
    contextHeadersInjected.current = true;
    injectContextHeaders({
      apolloUri: environment.REACT_APP_APOLLO_URI,
    });
  }, [environment.REACT_APP_APOLLO_URI]);

  if (!environment.REACT_APP_APOLLO_URI)
    return (
      <Box sx={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}>
        <Loader hAlign='center' vAlign='center' />
      </Box>
    );

  return <>{children}</>;
});
